import React, { lazy } from 'react';
import { useSelector } from 'react-redux';
import withSuspense from '../../../../../helpers/withSuspense.jsx';
import DynamicSkeletonGrid from '../../../../../skeleton_loaders/common/DynamicSkeletonGrid.jsx';
import ButtonSkeleton from '../../../../../skeleton_loaders/common/ButtonSkeleton.jsx';

const SeriesSettingsComponent = withSuspense(lazy(() => import('./SeriesSettings.jsx')), ({rowSizes}) =>
  <div style={{position: 'relative'}}>
    <DynamicSkeletonGrid rowSizes={rowSizes} gap={1} colSizes={['100%']} />
    <ButtonSkeleton buttonContent='_________' style={{marginTop: 20, position: 'absolute', right: 0}} />
  </div>
);

const SeriesSettings = (props) => {
  const series = useSelector(state => state.dashboard.widgets[props.widgetId].settings?.series || []);
  return (
    <SeriesSettingsComponent {...props} rowSizes={Array(series.length).fill(59)} />
  );
}


export default SeriesSettings;